const webinars = [
  {
    id: 'wb-001',
    titulo: 'Cómo gestionar tu inventario',
    fecha: '2026-06-15',
    hora: '15:00',
    duracion: '60 min',
    descripcion: 'Aprende las mejores prácticas para gestionar tu inventario de forma eficiente.',
    estado: 'finalizado',
    agenda: [
      { hora: '15:00', texto: 'Diagnóstico rápido de inventario y quiebres de stock.' },
      { hora: '15:20', texto: 'Métodos simples para ordenar productos de alta rotación.' },
      { hora: '15:45', texto: 'Preguntas y recomendaciones para aplicar en la tienda.' },
    ],
  },
  {
    id: 'wb-002',
    titulo: 'Estrategias de venta para tiendas',
    fecha: '2026-06-25',
    hora: '17:00',
    duracion: '45 min',
    descripcion: 'Descubre estrategias probadas para aumentar tus ventas y mejorar la rotación de stock.',
    estado: 'activo',
    agenda: [
      { hora: '17:00', texto: 'Productos gancho y oportunidades por horario de compra.' },
      { hora: '17:15', texto: 'Promociones simples para aumentar el ticket promedio.' },
      { hora: '17:35', texto: 'Cierre con casos reales de otros tenderos.' },
    ],
  },
  {
    id: 'wb-003',
    titulo: 'Optimiza tu tienda para temporada alta',
    fecha: '2026-06-10',
    hora: '11:00',
    duracion: '50 min',
    descripcion: 'Consejos prácticos para preparar tu tienda antes de las fechas de mayor demanda.',
    estado: 'finalizado',
    agenda: [
      { hora: '11:00', texto: 'Preparación de stock para días de mayor demanda.' },
      { hora: '11:20', texto: 'Cómo priorizar compras sin sobrecargar la caja.' },
      { hora: '11:40', texto: 'Checklist operativo para temporada alta.' },
    ],
  },
  {
    id: 'wb-004',
    titulo: 'Atención al cliente en tiendas modernas',
    fecha: '2026-07-05',
    hora: '16:00',
    duracion: '55 min',
    descripcion: 'Mejora la experiencia de tus clientes con estrategias simples y efectivas.',
    estado: 'activo',
    agenda: [
      { hora: '16:00', texto: 'Momentos clave de atención dentro de la tienda.' },
      { hora: '16:20', texto: 'Respuestas rápidas para reclamos y consultas frecuentes.' },
      { hora: '16:45', texto: 'Acciones para que tus clientes vuelvan más seguido.' },
    ],
  },
  {
    id: 'wb-005',
    titulo: 'Ventas cruzadas para aumentar ticket promedio',
    fecha: '2026-07-12',
    hora: '14:00',
    duracion: '40 min',
    descripcion: 'Aprende cómo ofrecer productos complementarios de forma natural y sin presión.',
    estado: 'activo',
    agenda: [
      { hora: '14:00', texto: 'Cómo detectar oportunidades de venta cruzada.' },
      { hora: '14:15', texto: 'Combos y sugerencias según productos del día a día.' },
      { hora: '14:30', texto: 'Ejercicios prácticos para aplicar en caja.' },
    ],
  },
  {
    id: 'wb-006',
    titulo: 'Cierre de mes ágil para tu tienda',
    fecha: '2026-06-18',
    hora: '10:00',
    duracion: '45 min',
    descripcion: 'Organiza tus procesos y evita errores comunes al cerrar el mes contable.',
    estado: 'finalizado',
    agenda: [
      { hora: '10:00', texto: 'Orden de ventas, pagos y cuentas pendientes.' },
      { hora: '10:15', texto: 'Errores frecuentes al revisar caja e inventario.' },
      { hora: '10:35', texto: 'Rutina mensual para cerrar con más claridad.' },
    ],
  },
];

export default webinars;
